<script setup>
defineProps({
  icon: {
    type: Object,
    required: false,
  },
})
</script>

<template>
  <button
    class="bg-secondary qmusic:uppercase text-primary-alt font-bold text-xl rounded shadow-lg py-2 px-3 hover:bg-opacity-80 flex items-center space-x-2 joe-be:bg-primary joe-be:rounded-full joe-be:px-5 joe-be:py-3 joe-be:font-medium joe:bg-primary joe:rounded-full joe:px-5 joe:py-3 joe:font-medium focus:ring-primary focus:ring-2 focus:ring-offset-4"
  >
    <component :is="icon" v-if="icon" class="w-6 h-6 joe:mr-1" />
    <span>
      <slot />
    </span>
  </button>
</template>
